"use strict";
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _styledComponents = require("styled-components");

var breakpoints = {
  hd: 1920,
  sd: 1366,
  cs: 1190,
  tablet: 1024,
  tabletPortrait: 800,
  phoneLarge: 680,
  phoneModal: 544,
  phone: 500
};

var _default = Object.keys(breakpoints).reduce(function (acc, label) {
  acc[label] = function () {
    return (0, _styledComponents.css)(["@media (max-width:", "em){", "}"], breakpoints[label] / 16, _styledComponents.css.apply(void 0, arguments));
  };

  return acc;
}, {});

exports.default = _default;
module.exports = exports.default;